import { createSlice } from '@reduxjs/toolkit';
import { detectInitialLocale } from '../i18n';

// Grid layout is per-user, but redux-persist keeps it in localStorage, which is per-browser.
// Logout has to put these back or the next user inherits the previous one's filters, hidden
// columns and saved query -- and on Tasks those can reference another org's custom columns.
// A factory rather than a shared object: the reset assigns these into an immer draft, which
// deep-freezes what it is handed.
const createInitialGridState = () => ({
    taskFilters: { items: [{}] },
    hazardFilters: { items: [{}] },
    taskQueryId: '',
    hazardColumns: {
        hzId: true,
        hzOrganizationName: true,
        hzProject: true,
        hzRiskSource: true,
        hzDepartmentName: true,
        hzProcess: true,
        hzJob: true,
        hzTask: true,
        hzEquipmentId: true,
        hzRiskScoreUncontrolled: true,
        hzRiskLevelUncontrolled: true,
        hzRiskScoreControlled: true,
        hzRisKLevelControlled: true
    },
    // `{}`, not undefined: DataGridPro reads an undefined visibility model as uncontrolled and
    // would flip to controlled on the first toggle. An empty model means the same thing --
    // every column visible -- without the switch.
    taskColumns: {},
});

export const correcttrackSlice = createSlice({
    name: 'correcttrack',
    initialState: {
        userToken: '',
        refreshToken: '',
        ...createInitialGridState(),
        language: detectInitialLocale(),
    },
    reducers: {
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        updateTaskFilters: (state, action) => {
            state.taskFilters = action.payload;
        },
        updateHazardFilters: (state, action) => {
            state.hazardFilters = action.payload;
        },
        updateTaskQuery: (state, action) => {
            state.taskQueryId = action.payload;
        },
        updateHazardColumns: (state, action) => {
            state.hazardColumns = action.payload;
        },
        updateTaskColumns: (state, action) => {
            state.taskColumns = action.payload;
        },
        logout: (state) => {
            state.userToken = '';
            state.refreshToken = '';
            state.forceResetPassword = false;
            // Drop the outgoing user's grid layout; see createInitialGridState.
            Object.assign(state, createInitialGridState());
        },
        updateUserToken: (state, action) => {
            state.userToken = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
        },
    }
});

export const { updateUserToken, logout, updateTaskFilters, updateHazardFilters, updateTaskQuery, updateHazardColumns, updateTaskColumns, setLanguage } = correcttrackSlice.actions;

export default correcttrackSlice.reducer;
